'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var index = require('../../../hooks/useOutsideClick/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var QuickActionPopover = function QuickActionPopover(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClose = _ref.onClose,
      arrow = _ref.arrow;
  var wrapperRef = React.useRef(null);
  index(wrapperRef, onClose);

  var styledChildren = function styledChildren() {
    return React__default['default'].Children.map(children, function (child) {
      return React__default['default'].cloneElement(child, {
        className: "ds-mol-quick-action-popover-element ".concat(child.props.className)
      });
    });
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    ref: wrapperRef,
    className: "ds-mol-quick-action-popover ".concat(arrow, "-arrow ").concat(className)
  }, styledChildren());
};

QuickActionPopover.propTypes = {
  className: PropTypes__default['default'].string,
  children: PropTypes__default['default'].node.isRequired,
  onClose: PropTypes__default['default'].func,
  arrow: PropTypes__default['default'].string
};
QuickActionPopover.defaultProps = {
  className: '',
  onClose: function onClose() {},
  arrow: 'top-right'
};

module.exports = QuickActionPopover;
